import React from 'react';
import { FaPlayCircle } from 'react-icons/fa';
import { urlWebsite } from '../../../../../config';
import { useConfiguration } from '../../../../../hooks/Configuration';
import { useLanguage } from '../../../../../hooks/Language';
import { useVideo } from '../../../../../hooks/Video';
import { date, dateWithHour } from '../../../../../utils/date';
import { AnimatedContainer } from '../../../styles';
import Favorite from '../../Favorite';
import { Block, FooterElement, Title } from './styles';

interface IVideos {
    before: any;
    waiting: any;
    online: any;

}


interface IProps {
    videos: IVideos
}

const Template: React.FC<IProps> = ({ videos }) => {
    const { translate } = useLanguage();
    const { openVideoByID, courses, videoStatus } = useVideo();
    const { configuration } = useConfiguration();



    const listBlock = ({ block, type, title }) => {

        const index = block?.list?.findIndex(i => i.visible === 'yes' || i.visible === '2');

        if (index < 0) {
            return <></>;
        }


        return (<>
            {videoStatus &&
                block &&
                block.list &&
                block.list.length > 0 &&
                <div style={{ display: 'flex', width: '100%', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <Block>
                        {block.list.map((lesson, index) => (
                            printLesson(lesson, index, type)))}
                    </Block> </div>
            }


        </>)
    }


    const getKeywords = (keywords: Array<string>) => {
        if (keywords && keywords.length > 0) {
            return <div className="keywordList">
                {keywords.map(key => <label>{key}</label>)}
            </div>
        }
        else {
            return <></>;
        }
    }

    const getSpeakers = (speakers: string) => {
        if (speakers && speakers.indexOf(';') > 0) {

            const listSpeakers = speakers.split(";");

            if (listSpeakers && listSpeakers.length >= 0) {
                return <div className="speakerList">
                    {listSpeakers.map(speaker => <p>{speaker}</p>)}
                </div>
            }


        }
        else {
            return <></>;
        }
    }

    const printLesson = (lesson, index, type) => {

        const statusSelector = {
            "1": translate('Em breve'),
            "2": <><div className="redBall" /> {translate('Ao vivo')}</>,
            "3": translate('Finalizado')
        }





        return (
            <div key={`posterDiv${lesson._id}`} style={{ position: 'relative' }} onClick={() => { openVideoByID(courses, lesson._id) }}
                className={`posterDisplay `}

            >

                <div className='posterImageDiv'>
                    <div className='play'>
                        <FaPlayCircle />
                    </div>
                    {lesson.image ?
                        <img key={`img-${lesson._id}`}
                            className="posterImage"
                            src={lesson.image ? `${urlWebsite}/${lesson.image}` : '/apoio/biblioteca/capa.jpeg'}
                        /> : <div className='eventTitle'><h2>

                        </h2></div>}
                </div>
                <div className='contentDiv'>
                    {lesson?.room_name ? <p className='episodio'>{lesson.room_name}</p> : <></>}

                    {lesson?.title ? <h2>{lesson.title}</h2> : <></>}
                    {lesson?.category_name ? <p>{lesson.category_name}</p> : <></>}
                    <div className='typeButtonDiv'>
                        <button className='typeButtonInitial'>{type === 'waiting' ? dateWithHour(lesson?.release_date) : type === 'online' ? 'Live' : 'On demand'}</button>
                        <button className='typeButton'>{type === 'waiting' ? 'Em breve' : 'Disponível'}</button>

                    </div>

                </div>

            </div>


        );

    }

    return (<>
        {videoStatus.type === 'list' ? <Title >{configuration?.current_event_id_response?.title} </Title> : <></>}
        {listBlock({ block: videos.online, type: "online", title: translate('Online Agora') })}
        {listBlock({ block: videos.waiting, type: "waiting", title: translate('Em breve') })}
        {listBlock({ block: videos.before, type: "before", title: translate('On Demand') })}
        {videoStatus.type === 'list' ? <FooterElement>
            <img src="/apoio/ilustracao1.png" style={{ width: '300px', marginTop: '-150px' }} />
        </FooterElement> : <></>}
    </>);

}

export default Template;